import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isCustomerUser } from "../utils/jwtRole";

export function useIsCustomer() {
  const location = useLocation();
  const readCustomer = useCallback(() => isCustomerUser(), []);
  const [isCustomer, setIsCustomer] = useState(readCustomer);

  useEffect(() => {
    setIsCustomer(readCustomer());
  }, [location.pathname, location.key, readCustomer]);

  useEffect(() => {
    const onAuthUpdate = () => setIsCustomer(readCustomer());
    window.addEventListener("storage", onAuthUpdate);
    window.addEventListener("sundorbon-auth-updated", onAuthUpdate);
    return () => {
      window.removeEventListener("storage", onAuthUpdate);
      window.removeEventListener("sundorbon-auth-updated", onAuthUpdate);
    };
  }, [readCustomer]);

  return isCustomer;
}

export default useIsCustomer;
